import React from 'react';
import { useHistory } from 'react-router-dom';
import { find } from 'lodash';
import { useSelector } from 'react-redux';
import { Button } from '../utils/forms/Button';
import { SHARE_PLACE_ROUTE, BOOKING_FORM } from '../router/routes';

export default function MainPage() {
  const history = useHistory();
  const userId = useSelector((state) => state.auth.id);
  const userPlace = useSelector((state) =>
    find(state.spots, (spot) => spot.userId === userId)
  );
  return (
    <div className="signpost">
      <Button
        style={{
          backgroundColor: '#87AB31'
        }}
        type="button"
        color="secondary"
        onClick={() =>
          history.push(
            SHARE_PLACE_ROUTE.replace(':spotId', userPlace.placeId),
            userPlace
          )
        }
      >
        Sdílet své stálé místo
      </Button>
      <div className="signpost__section">Nebo</div>
      <Button
        type="primary"
        color="secondary"
        onClick={() => history.push(BOOKING_FORM)}
      >
        Pokračovat na rezervace
      </Button>
    </div>
  );
}
